import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetInfoAndPassService {

    accessRightSection: Observable<any>;
    accessUserSection: Observable<any>;
    private accessRightSectionSubject = new BehaviorSubject<any>("");
    private accessUserSectionSubject = new BehaviorSubject<any>("");

    constructor() {
      this.accessRightSection = this.accessRightSectionSubject.asObservable();
      this.accessUserSection = this.accessUserSectionSubject.asObservable();
    }

    getInfoAndPass(data, user?) {
      this.accessRightSectionSubject.next(data);
      this.accessUserSectionSubject.next(user);
    }

    clearData() {
      this.accessRightSectionSubject.next("");
      this.accessUserSectionSubject.next("");
    }
}
